import React from "react";
import { Link } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import "./sahibindenFilters.css";

// Kategori ağacında verilen slug'a giden yolu (root → ... → düğüm) döndürür.
const findPath = (nodes, slug, trail = []) => {
  for (const node of nodes || []) {
    const next = [...trail, node];
    if (node.slug === slug) return next;
    const childTrail = findPath(node.hierarchy, slug, next);
    if (childTrail) return childTrail;
  }
  return null;
};

function CategoryNav({ currentSlug, onNavigate }) {
  const { categories } = useSelector(
    (state) => ({ categories: state.category.categories }),
    shallowEqual
  );

  if (!categories || categories.length === 0) return null;

  const path = findPath(categories, currentSlug) || [];
  const activeSlugs = new Set(path.map((n) => n.slug));

  // Sadece aktif dalı genişlet; diğer kökler kapalı kalır (sahibinden tarzı).
  const renderList = (nodes, depth) => (
    <ul className="cat-nav-list">
      {nodes.map((node) => {
        const isActive = node.slug === currentSlug;
        const onPath = activeSlugs.has(node.slug);
        const children = node.hierarchy || [];
        return (
          <li key={node.slug}>
            <Link
              to={`/kategori/${node.slug}`}
              onClick={onNavigate}
              className={`cat-nav-item${isActive ? " active" : ""}`}
              style={{ paddingLeft: 12 + depth * 14 }}
            >
              {node.name}
            </Link>
            {onPath && children.length > 0 && renderList(children, depth + 1)}
          </li>
        );
      })}
    </ul>
  );

  return (
    <div className="cat-nav">
      <div className="cat-nav-head">Kategoriler</div>
      {renderList(categories, 0)}
    </div>
  );
}

export default CategoryNav;
